import { ISubject } from '../material/material.types'
import { Material } from 'src/api/endpoints/materials'

export type Status =
    | 'Не сделано'
    | 'На проверке'
    | 'Выполнено'
    | 'Просрочено'
    | 'На пересдаче'

export enum HomeworkStatusColor {
    'Не сделано' = '#D97706',
    'На проверке' = '#D97706',
    'Выполнено' = '#16A34A',
    'Просрочено' = '#dc2626',
    'На пересдаче' = '#D97706',
}

export interface ITask {
    id: number
    material: Material;
    description: string
    createdAt: number
    expiresAt: number
    status: Status
    lessonLink: string
}

export interface IHomeworkData {
    total: number
    upcoming: number
    expired: number
    completed: number
    pending: number
    tasks: ITask[]
    subjects: ISubject[]
}

export interface IHomeworkState {
    data: IHomeworkData
    isLoading: boolean
    hasLoaded: boolean
}
